<script>
import ExpandableContainer from '@/V2/components/expandable-container/ExpandableContainer.vue';
import ExpandableContainerItem from '@/V2/components/expandable-container/ExpandableContainerItem.vue';
import {
  iBadge,
  iBadgeColours,
  iButton,
  iButtonTypes,
  iButtonSizes,
  iButtonStyles,
  showToast,
  iKeyIcon,
  iKeyIconSize,
  iKeyIconShape,
  iKeyIconStyle,
  iKeyIconType,
  iTooltip,
  iTooltipAlignmentMode,
} from '@inscribe/signal';

export default {
  components: {
    ExpandableContainer,
    ExpandableContainerItem,
    iBadge,
    iButton,
    iKeyIcon,
    iTooltip,
  },
  props: {
    customerProfile: {
      type: Object,
    },
    personalDetailsFields: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      iBadgeColours,
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
      iKeyIconSize,
      iKeyIconShape,
      iKeyIconStyle,
      iKeyIconType,
      iTooltipAlignmentMode,
    };
  },
  computed: {
    personalDetails() {
      const data = this.customerProfile;
      const personalDetails = this.personalDetailsFields
        .map((field) => {
          const value = this.getItemFromPath(data, field.path);
          return this.isDataEmpty(value)
            ? {
                label: field.label,
                value: value,
                source: value?.source || data?.source,
                icon: field.icon,
              }
            : undefined;
        })
        .filter((item) => item !== undefined)
        .filter(
          (item) =>
            item.label.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            item.value.toLowerCase().includes(this.searchQuery.toLowerCase()),
        );
      return personalDetails;
    },
    containerTitle() {
      return this.customerProfile?.person_name?.value || 'Personal Details';
    },
    containerSubtitle() {
      return this.customerProfile?.person_name?.value
        ? 'Personal Details'
        : undefined;
    },
  },
  methods: {
    isDataEmpty(data) {
      return !!data && data !== '' && data.length > 0;
    },
    getItemFromPath(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    },
    onItemClick(item) {
      this.$emit('onItemClick', item);
    },
    copyToClipboard(value) {
      navigator.clipboard.writeText(value);
      showToast({
        title: 'Copied',
        text: `Value successfully copied`,
      });
    },
  },
};
</script>

<template>
  <div class="customer-profile-personal-details d-flex flex-column i-gap-11">
    <expandable-container :title="containerTitle" :subtitle="containerSubtitle">
      <template #items>
        <expandable-container-item
          v-for="(item, itemIndex) in personalDetails"
          :key="itemIndex"
          :title="item.label"
          :subtitle="item.value"
          :reverse-fonts="true"
          @on-item-click="onItemClick(item)"
          @on-right-icon-click="onItemClick(item)"
        >
          <template #left-container>
            <i-key-icon
              :icon="item.icon"
              :size="iKeyIconSize.SM"
              :shape="iKeyIconShape.SQUARE"
              :icon-style="iKeyIconStyle.OUTLINE"
              :type="iKeyIconType.NEUTRAL"
            />
          </template>

          <template #right-container>
            <i-badge
              v-if="item.source"
              :colour="iBadgeColours.NEUTRAL"
              icon="small-solid-info"
              :has-leading-icon="true"
              :label="item.source"
              :outline="true"
              :interactable="true"
            ></i-badge>
          </template>

          <template #hover-right-container>
            <i-button
              :id="`copy-to-clipboard-button-individual-${itemIndex}`"
              left-icon="small_align_back"
              :size="iButtonSizes.XSMALL"
              :type="iButtonTypes.NEUTRAL"
              :button-style="iButtonStyles.SOLID_LIGHT"
              @button-click="copyToClipboard(item.value)"
            />
            <i-tooltip
              :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
              title="Copy"
              :target="`#copy-to-clipboard-button-individual-${itemIndex}`"
            />
          </template>
        </expandable-container-item>
      </template>
    </expandable-container>
  </div>
</template>
